import React from 'react';

const AdSlot = ({ slotId }) => {
  return (
    <div 
      id={slotId}
      data-testid={slotId}
    />
  );
};

export default AdSlot;